import { RepeatableThreeInputsWithTextEditor } from "@/components";
import React from "react";

const ServiceTypesFieldSection = ({
  control,
  errors,
  formData,
  handleAddRepeatableField,
  handleOnChangeRepeatableFields,
  handleRemoveRepeatableField,
  isItemDetailsExist = false,
  isHideInOtherLanguages = false,
}) => {
  return (
    <>
      {/* Training Details Repeater */}
      <RepeatableThreeInputsWithTextEditor
        formData={formData}
        labelText="Service Types"
        fieldId={isItemDetailsExist ? "service-update-types" : "service-types"}
        translateField={isItemDetailsExist}
        repeatableKeyname="service_types"
        repeatableKeys={["titles", "short_descriptions", "descriptions"]}
        addNewField={handleAddRepeatableField}
        removeField={handleRemoveRepeatableField}
        onChangeField={handleOnChangeRepeatableFields}
        inputBoxMaxWidth="xl:max-w-[500px]"
      />
    </>
  );
};

export default ServiceTypesFieldSection;
